import { useFormContext } from 'react-hook-form';
import { LwAutocomplete } from 'redesign';
import { useMemo } from 'react';
import { WorkerForSelect } from 'api/services/workers/workers-service.dto';
import { TimeSlotFormContext } from './time-slot.types';
import { formatWorkerLabel } from '../utils/format-worker-label';

export const AvailabilityWorkersSelect = ({
  disabled = false,
  workerOptions = [],
  flexWorkerSearch,
  setFlexWorkerSearch,
}: {
  flexWorkerSearch: string;
  setFlexWorkerSearch: (search: string) => void;
  disabled?: boolean;
  workerOptions?: WorkerForSelect[];
}) => {
  const { resetField, setValue, watch } = useFormContext<TimeSlotFormContext>();
  const selectedWorker = watch('workerSelect');
  const flexWorkerOption = useMemo(() => {
    const option = workerOptions.find((worker) => worker.workerId === selectedWorker) ?? null;
    if (!option) {
      return undefined;
    }
    return {
      label: formatWorkerLabel(option),
      value: option?.workerId,
    };
  }, [selectedWorker, workerOptions]);

  const options = useMemo(
    () =>
      workerOptions.map((worker) => ({
        label: formatWorkerLabel(worker),
        value: worker.workerId,
      })),
    [workerOptions]
  );
  return (
    <LwAutocomplete
      isLoading={false}
      label="Flexwerker"
      error={false}
      helperText={undefined}
      inputValue={flexWorkerSearch}
      value={flexWorkerOption ?? undefined}
      rules={{ required: true }}
      name="workerSelect"
      options={options}
      noOptionsText={'Typ minstens 3 tekens om te zoeken'}
      isOptionEqualToValue={(option, value) => option?.value === value.value}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) => option.label}
      onInputChange={(_e, value) => {
        setFlexWorkerSearch(value);
      }}
      onChange={(_, option) => {
        setValue('workerSelect', option?.value);
        resetField('availability');
      }}
      disabled={disabled}
    />
  );
};
